import React from "react";
import { CheckCircle2, Users, Sparkles, Heart } from "lucide-react";
import { BRAND } from "../lib/brand";

const values = [
  { icon: Heart, title: "Warm, family-style care", desc: "Each child is known by name and personality." },
  { icon: Users, title: "Small group sizes", desc: "More attention, more conversation, more growth." },
  { icon: Sparkles, title: "Joyful learning", desc: "Stories, songs, art and play in every day." },
  { icon: CheckCircle2, title: "Nepali roots", desc: "Language, culture and values built into our classroom." },
];

const AboutPage = () => (
  <main className="pt-32 pb-24 min-h-screen" data-testid="about-page">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">About us</span>
        <h1 className="font-heading text-4xl sm:text-5xl font-bold mt-2">A Nepalese-concept preschool with heart</h1>
        <p className="mt-3 text-[color:var(--text-secondary)]">Founded in 2017 in Panga, Kirtipur. Built for every little learner.</p>
      </div>

      <div className="grid lg:grid-cols-12 gap-10 items-center mb-16">
        <div className="lg:col-span-5 relative">
          <div className="absolute -top-6 -left-6 w-28 h-28 rounded-full bg-brand-yellow/60" />
          <div className="absolute -bottom-6 -right-6 w-32 h-32 rounded-[36%] bg-brand-blue/10" />
          <div className="relative bg-white rounded-[2rem] p-8 shadow-[0_20px_50px_rgba(30,91,184,0.12)] overflow-hidden">
            <div className="absolute inset-0 dotted-pattern opacity-20" aria-hidden />
            <img
              src={BRAND.aboutIllustration}
              alt="Children playing and learning"
              className="relative w-full h-[400px] object-contain"
            />
          </div>
        </div>
        <div className="lg:col-span-7">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold mb-4">Our story</h2>
          <p className="text-[color:var(--text-secondary)] leading-relaxed mb-4">
            Innovative Preschool opened its doors in 2017 with a simple, clear belief: every child arrives with
            their own innate qualities, and our job as early educators is to recognise, respect, and gently grow them.
          </p>
          <p className="text-[color:var(--text-secondary)] leading-relaxed mb-4">
            We're not a one-size-fits-all classroom. We're a place where each child is seen — and where Nepali language,
            songs, and culture are part of the everyday rhythm.
          </p>
          <p className="text-[color:var(--text-secondary)] leading-relaxed">
            Eight joyful years on, we continue to welcome families from Kirtipur and across Kathmandu Valley.
            Many of our first students have already moved on to primary school carrying the same confidence
            and curiosity we nurtured together.
          </p>
        </div>
      </div>

      <h2 className="font-heading text-2xl sm:text-3xl font-bold text-center mb-8">What we believe in</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {values.map((v, i) => (
          <div key={i} className="card-soft bg-white p-6" data-testid={`about-value-${i}`}>
            <div className="w-12 h-12 rounded-2xl bg-light-blue flex items-center justify-center mb-4">
              <v.icon className="text-brand-blue" size={22} />
            </div>
            <h3 className="font-heading font-bold mb-2">{v.title}</h3>
            <p className="text-sm text-[color:var(--text-secondary)]">{v.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </main>
);

export default AboutPage;
